var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.223,
    height: 26.123,
    viewBox: "0 0 15.223 26.123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uBAA8\\uC11C\\uB9AC\\uAC00_\\uB465\\uADFC_\\uC9C1\\uC0AC\\uAC01\\uD615_1_\\uBCF5\\uC0AC",
    "data-name": "\\uBAA8\\uC11C\\uB9AC\\uAC00 \\uB465\\uADFC \\uC9C1\\uC0AC\\uAC01\\uD615 1 \\uBCF5\\uC0AC",
    d: "M893.21,541.875a2.134,2.134,0,0,1,0-3.009l9.507-9.548-9.347-9.388a2.088,2.088,0,0,1,0-2.945,2.066,2.066,0,0,1,2.932,0l10.478,10.524a2.133,2.133,0,0,1,.412,3.332l-10.986,11.034a2.111,2.111,0,0,1-3,0Z",
    transform: "translate(-892.589 -516.375)",
    fill: "#ddd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGray);
export default __webpack_public_path__ + "static/media/arrow-gray.0d41c4e7a592830471bc878bfd4c653d.svg";
export { ForwardRef as ReactComponent };